import cx from "clsx";
import CustomButton from "kreate-common/modules/kreate-ui/components/CustomButton";
import InputV2 from "kreate-common/modules/kreate-ui/components/InputV2";
import { useRouter } from "next/router";
import React from "react";
import { MdCancel, MdSearch } from "react-icons/md";

import styles from "./index.module.scss";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  searchInput: string;
  onSearchInputChange?: (searchInput: string) => void;
  state: "artists" | "artworks" | "collections";
};

const ButtonToggle = CustomButton.withDefaultProps({
  className: styles.buttonToggle,
  size: "md",
  color: "inherit",
});

const ButtonClear = CustomButton.withDefaultProps({
  className: styles.buttonClear,
  padding: "minimal",
  color: "inherit",
  size: "xs-square",
});

export default function PanelSearch({
  className,
  style,
  searchInput,
  onSearchInputChange,
  state,
}: Props) {
  const router = useRouter();

  return (
    <div className={cx(styles.container, className)} style={style}>
      <InputV2
        alwaysShrinkLabel
        className={styles.input}
        size="xl"
        value={searchInput}
        onChange={onSearchInputChange}
        placeholder="Search"
        leftAdornment={
          <InputV2.Adornment>
            <MdSearch />
          </InputV2.Adornment>
        }
        rightAdornment={
          <InputV2.Adornment>
            <ButtonClear
              style={{ opacity: searchInput ? "100%" : "0%" }}
              content={<MdCancel size="24px" />}
              onClick={() => onSearchInputChange?.("")}
            />
          </InputV2.Adornment>
        }
      />
      <div className={styles.buttonGroup}>
        <ButtonToggle
          size="md"
          content={"Artworks"}
          {...(state === "artworks" ? { "data-toggled-on": true } : undefined)}
          onClick={() =>
            router.push({
              pathname: "/explore/artworks",
              query: { q: searchInput },
            })
          }
        />
        <ButtonToggle
          size="md"
          content={"Collections"}
          {...(state === "collections"
            ? { "data-toggled-on": true }
            : undefined)}
          onClick={() =>
            router.push({
              pathname: "/explore/collections",
              query: { q: searchInput },
            })
          }
        />
        <ButtonToggle
          size="md"
          content={"Artists"}
          {...(state === "artists" ? { "data-toggled-on": true } : undefined)}
          onClick={() =>
            router.push({
              pathname: "/explore/artists",
              query: { q: searchInput },
            })
          }
        />
      </div>
    </div>
  );
}
